import React, {useContext, useEffect, useState} from 'react';
import Select, {createFilter} from 'react-select';
import Switch from "react-switch";
import makeAnimated from 'react-select/animated';
import {Context} from "../ApiClient";
import {EventCalendarContext} from "./EventCalendar";
import * as date from "../util/date";


export default function Filters(props) {

    // Getting object containing events from context, so we need to use braces
    let {events}      = useContext(Context);
    let {territories} = useContext(Context);
    let {eventThemes} = useContext(Context);

    let eventCalendarContext = useContext(EventCalendarContext);


    let [activeThemes, setActiveThemes]           = useState([]);
    let [activeTerritories, setActiveTerritories] = useState([]);
    let [searchValue, setSearchValue]                 = useState('');

    useEffect(() => {
        eventCalendarContext.callbackActiveFilters({activeTerritories, activeThemes, searchValue});
        // eslint-disable-next-line
    }, [activeThemes, activeTerritories, eventCalendarContext.activeDate, eventCalendarContext.monthMode, events, searchValue]);

    useEffect(() => {
        changeDate(0);
        // eslint-disable-next-line
    }, [eventCalendarContext.monthMode]);


    const filterConfig = {
        ignoreAccents: true, ignoreCase: true, trim: true
    }

    function changeDate(direction) {
        let newDate = new Date(eventCalendarContext.activeDate);

        //Check if monthMode is true
        if (eventCalendarContext.monthMode) {
            newDate.setMonth(newDate.getMonth() + direction);
            eventCalendarContext.calendarRef.current.getApi().gotoDate(newDate);
        }
        else {
            newDate.setFullYear(newDate.getFullYear() + direction);
        }
        eventCalendarContext.setActiveDate(newDate);
    }

    function formatAsOptions(array) {
        let options = [];

        if (Array.isArray(array)) {
            array.forEach(function (item) {
                options.push({value: item.title, label: item.title});
            });
        }

        return options;
    }

    return (// if events is not empty, then render the event list
        <div>
            <div className="fc-toolbar fc-header-toolbar">
                <div className="fc-left">
                    <div className="fc-button-group">
                        <button onClick={() => {
                            changeDate(-1)
                        }} type="button" className="fc-prev-button fc-button fc-button-primary" aria-label="prev">
                            <span className="fc-icon fc-icon-chevron-left"></span></button>
                        <button onClick={() => {
                            changeDate(1)
                        }} type="button" className="fc-next-button fc-button fc-button-primary" aria-label="next">
                            <span className="fc-icon fc-icon-chevron-right"></span></button>
                    </div>
                </div>
                {eventThemes.length > 0 &&
                    <Select options={formatAsOptions(eventThemes)} isMulti isSearchable={true} placeholder={'Thématiques'}
                            openMenuOnClick={false} filterOption={createFilter(filterConfig)}
                            components={makeAnimated()}
                            onChange={setActiveThemes}
                            className="react-select"
                    />}
                <div className="fc-center"><h2>{date.formatDateTime(eventCalendarContext.activeDate, eventCalendarContext.monthMode ? 'month year' : 'year')}</h2>
                </div>
                {territories.length > 0 &&
                    <Select options={formatAsOptions(territories)} isMulti isSearchable={true}
                            placeholder={'Territoires'}
                            openMenuOnClick={false} filterOption={createFilter(filterConfig)}
                            components={makeAnimated()}
                            onChange={setActiveTerritories}
                            className="react-select"
                    />}
                <div className="fc-right">
                    <Switch checked={eventCalendarContext.monthMode} onChange={eventCalendarContext.setMonthMode} onColor="#005683" offColor="#219d3c"
                            checkedIcon={<span>Mois</span>} uncheckedIcon={<span>Année</span>} width={80}></Switch>
                </div>
            </div>
            <div className={"fc-toolbar fc-header-toolbar"}>
                <input className={'searchBar'} type={"search"} onChange={e => setSearchValue(e.target.value)} placeholder={'Rechercher'}/>
            </div>
        </div>)
}